import React from 'react'
import _get from 'lodash/get'
import config from '~/config'

const SALINITY = _get(config, 'app.parameters', []).find(p => p.name === 'ความเค็ม')

const scales = SALINITY.scales.map(([min, color]) => ({
  color
}))
scales[0].label = '< 0.2 g/L'
scales[1].label = '0.2 - 0.25 g/L'
scales[2].label = '> 0.25 g/L'

const SalinityLegend = () => <div className="legend" style={{ position: 'absolute', bottom: '30px', left: '10px', backgroundColor: 'white', fontSize: '12px' }}>
  {
    scales.map(({ label, color }) => <span key={label} style={{ display: 'inline-block' }}>
      <div style={{ backgroundColor: color, width: '80px', height: '10px' }}></div>
      <div style={{ textAlign: 'center' }}>{label}</div>
    </span>)
  }
</div>

export default SalinityLegend



// WEBPACK FOOTER //
// ./src/components/SalinityLegend.js